import { ToastProps } from './Toast';
import ToastManager from './ToastManager';

const ToastEvents = {
  container: null as ToastManager | null,
  mount(comp: ToastManager) {
    this.container = comp;
  },
  show(options: ToastProps) {
    if (this.container) {
      this.container.showToast(options);
    }
  }
};

export default ToastEvents;
